export default "__VITE_ASSET__CZ1_vCsM__"